<template>
<div class="weather-container">
    <div class="icon-container" 
        @click="full_forcast" 
        @mouseover="show_weather_box = true" @mouseleave="show_weather_box = false " 
        :title="`${weather_title} - hover to see full weather`" >
        <svg v-if="loading" class="w-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="21" viewBox="0 0 24 24" fill="white" >
            <path d="M22 12c0 5.514-4.486 10-10 10s-10-4.486-10-10 4.486-10 10-10 10 4.486 10 10zm-22 0c0 6.627 5.373 12 12 12s12-5.373 12-12-5.373-12-12-12-12 5.373-12 12zm16 5l-4-11-4 11 4-2 4 2z"/>
        </svg>
        <img v-else :src="get_weather_icon(conditions.WeatherIcon)" alt="Current weather icon">
        <!-- this is a temprary comment -->
    </div>
    <div v-show="show_weather_box" class="weather-details" >
        <div class="weather-details-wrapper" 
            @mouseover="show_weather_box = true" @mouseleave="check_mouse_leave" 
            @click="force_show_weather_box" v-click-outside="closeWidget" >
            <div class="widget">
                <div class="weather-line weather-text">
                    <div v-if="loading == true && !has_weather" class="weather">Loading weather...</div>
                    <div v-else-if="has_weather" class="weather">{{weather_text}}</div>
                    <div v-else class="weather">Unable to get weather.</div>
                </div>
                <div class="weather-line weather-search" :class="{'make-visible': show_search}">
                    <form @submit.prevent="make_location_search" >
                        <div class="input-group">
                            <label for="weather-location-search" class="sr-only" >Search for weather location</label>
                            <input type="text" id="weather-location-search" class="weather-location-search" 
                                name="weather-location-search" placeholder="Enter location" 
                                ref="search-input" v-model="search_location" 
                                @enter.prevent="make_location_search" :disabled="searching" >
                            <div class="input-btn-group" >
                                <button type="button" title="Search for weather locations" @click="make_location_search" :disabled="searching" >
                                    <img v-if="searching == false" src="/asset/section/AccuWeather/icons/icon-search.png" alt="Search eyeglass icon "/>
                                    <img v-else class="spinner" src="/asset/section/AccuWeather/icons/icon-spinner.png" alt="loading icon"/>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                <div v-if="has_weather" class="weather-line weather-link">
                    <div class="full-weather">
                        <a :href="weather.link">Full Forecast &rsaquo;</a>
                    </div>
                    <div @click="toggleSearch" class="search-icon" :class="{'make-hidden': show_search}" title="Select a different location" >
                        <img src="/asset/section/AccuWeather/icons/icon-search.png" alt="Search eyeglass icon"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data(){
        return {
            accu_key: "8e7965ebd7f34b88a4a393918d246f1b",
            api_type: "api",
            is_dev: false,
            loc_key: '',
            location: {},
            conditions: {},

            loading: true,

            weather: {
                temp: null,
                unit: '',
                text: '',
                city: '',
                link: '',
            },

            show_search: false,
            searching: false,
            search_location: '',
            force_show_weather_box_flag : false, //Only true if user clicks anywhere in the box

            show_weather_box: false,

            is_logged_in: false,
            member_id: null,
            member: null,

            accu_loc_cookie_name: 'accu_weather_loc_key',
            partner_code: 'web_realclear_adc',
        };
    },
    
    beforeCreate(){
        console.log("weather app")
    },

    created(){

        this.loading = true;
        window.visitor_ip = null;

        if( this.is_dev ){
            this.api_type = "apidev";
        }

        var loc_key = getCookie(this.accu_loc_cookie_name);
        if( loc_key !== null ){
            this.loc_key = loc_key;
            this.get_location_by_location_key();
        }else{
            this.get_the_ip();
        }
    },
    computed: {

        has_weather(){

            return this.weather.temp !== null;
        },

        weather_text(){

            if(!this.has_weather){
                return '';
            }

            var weather = this.weather.temp+'°'+this.weather.unit+' '+this.weather.text+' in '+this.weather.city;

            if( this.location.AdministrativeArea.LocalizedType == 'State' ){
                weather += ', '+this.location.AdministrativeArea.ID;
            }

            return weather;
        },

        weather_title(){

            if(!this.has_weather){
                return '';
            }

            return this.weather.temp+'°'+this.weather.unit+' '+this.weather.text;
        },

    },
    methods: {

        update_member_location(){

            if( is_member_logged_in() === false
                || ( Object(this.member).length > 0 && this.loc_key == this.member.accu_loc_key ) ){
                return;
            }

            this.get_user_info_for_updating();
        },

        get_user_auth_data(){
            return {
                token: getCookie('rcmg_token'),
                guid: getCookie('rcmg_guid'),
                userAgent: navigator.userAgent
            };
        },

        get_user_info_for_updating(){

            if(this.user_id !== null){
                this.update_member_accu_location();
                return;
            }

            rcmg_api_call('get_user_info', this.get_user_auth_data(), function(res){
                // console.log(res);
                this.set_user_data(res);
                this.is_logged_in = true;
                this.update_member_accu_location();
            }.bind(this));
        },

        set_user_data(res){
            this.member_id  = res.data.user_id;
            this.member     = res.data;
        },

        update_member_accu_location(){

            var data = this.get_user_auth_data();
            data.accu_location = this.location.Key;

            rcmg_api_call('update_user_weather_location', data, function(res){
                // console.log(res);
            });
        },

        toggle_weather_box(){
            this.show_weather_box = (this.show_weather_box == true) ? false : true;

            if( this.show_weather_box == false ){
                this.show_search = false;
            }
        },

        full_forcast(){
            window.location = this.weather.link;
        },

        toggleSearch(){

            this.show_search = (this.show_search == true) ? false : true;

            if(this.show_search){

                setTimeout(() => {
                    this.$refs['search-input'].focus();
                }, 250);
            }
        },

        make_location_search(){

            if(this.searching === true || this.search_location === null || this.search_location.length === 0){
                return;
            }

            this.searching = true;

            $.ajax({
                url: "https://"+this.api_type+".accuweather.com/locations/v1/search?q="+this.search_location+"&apiKey="+this.accu_key,
                success: function(data){
                    // console.log(data);

                    if( Array.isArray(data) && data.length > 0 ){
                        this.loc_key = data[0].Key;
                        this.location = data[0];
                        setCookie(this.accu_loc_cookie_name, data[0].Key, 365);
                        setCookie('accu_location', JSON.stringify(data[0]), 365);
                        this.update_member_location();
                        this.get_current_conditions();
                        this.search_location = '';
                    }else{

                        this.searching = false;
                        setTimeout(function(){
                            this.$refs['search-input'].focus();
                        }.bind(this), 250);
                    }

                }.bind(this),

            });
        },

        get_the_ip(){
            // console.log("GET THE IP");

            var $this = this;

            var script = document.createElement('script');
            script.id = "l2.io-ip.js";

            script.onload = function(){
                $this.get_location_id();
            }

            script.src = "https://l2.io/ip.js?var=visitor_ip";

            document.head.appendChild(script);
        },

        get_location_id(){
            // console.log("GET LOCATION ID BY IP");

            var new_location = false;

            // if not set or different value
            var cookie_ip = getCookie('visitor_ip');
            if( cookie_ip === null || cookie_ip !== window.visitor_ip ){
                setCookie('visitor_ip', window.visitor_ip, 1);
                new_location = true;
            }

            var cookie_loc_key = getCookie(this.accu_loc_cookie_name);
            if( cookie_loc_key !== null && new_location == false ){
                this.loc_key = cookie_loc_key;
                this.location = JSON.parse(getCookie('accu_location'));
                this.get_current_conditions();
                return;
            }

            $.ajax({
                url: "https://"+this.api_type+".accuweather.com/locations/v1/cities/ipaddress?q="+window.visitor_ip+"&apikey="+this.accu_key,
                success: (data) => {
                    // console.log(data);

                    // if no data was returned from API but we have data in cookie use that
                    if( (data === null || Object.keys(data).length == 0) && getCookie('accu_location') !== null ){

                        data = JSON.parse(getCookie('accu_location'));

                        // else if we don't have loc data so just exit early
                    }else if(data === null || Object.keys(data).length == 0){
                        return;
                    }

                    this.loc_key    = data.Key;
                    this.location   = data;
                    setCookie(this.accu_loc_cookie_name, data.Key, 1);
                    setCookie('accu_location', JSON.stringify(data), 1);
                    this.update_member_location();
                    this.get_current_conditions();
                },
                error: (error) => {
                    console.log("ERROR", error);
                    // this.loading = false;
                    // this.searching = false;
                },
            });
        },

        /**
         * Get the location by a location key
         * If it fails to get the location by key then it goes to the IP address
         */
        get_location_by_location_key: function(custom_loc){
            // console.log('get_location_by_location_key');

            var $this = this;
            var location_key = this.loc_key;
            if(custom_loc){
                location_key = custom_loc;
            }

            $.ajax({
                url: "https://"+this.api_type+".accuweather.com/locations/v1/"+location_key+".json?apikey="+this.accu_key,
                success: function(data){

                    // if no data was returned from API but we have data in cookie use that
                    if( (data === null || Object.keys(data).length == 0) && getCookie('accu_location') !== null ){

                        data = JSON.parse(getCookie('accu_location'));

                        // else if we don't have loc data so just exit early
                    }else if(data === null || Object.keys(data).length == 0){
                        $this.get_the_ip();
                        return;
                    }

                    $this.loc_key    = data.Key;
                    $this.location   = data;
                    setCookie($this.accu_loc_cookie_name, data.Key, 365);
                    setCookie('accu_location', JSON.stringify(data), 365);
                    $this.get_current_conditions();
                },
                error(){
                    $this.get_the_ip();
                },
            });
        },

        get_current_conditions(){
            // console.log('get_current_conditions');

            $.ajax({
                url: "https://"+this.api_type+".accuweather.com/currentconditions/v1/"+this.loc_key+".json?apikey="+this.accu_key+'&cache='+(new Date().getMilliseconds()),
                success: function(data){
                    // console.log(data);
                    this.conditions = data[0];

                    // console.log("GET WEATHER ICON", this.conditions, this.conditions.WeatherIcon, this.get_weather_icon(this.conditions.WeatherIcon));
                    // console.log("CONDITIONS", this.conditions);

                    this.weather.temp = this.conditions.Temperature.Imperial.Value;
                    this.weather.unit = this.conditions.Temperature.Imperial.Unit;
                    this.weather.text = this.conditions.WeatherText;
                    this.weather.city = this.location.LocalizedName;
                    this.weather.link = this.conditions.Link;

                    if( this.weather.link !== null && this.weather.link.indexOf('?') == -1 ){
                        this.weather.link = this.weather.link+'?partner='+this.partner_code;
                    }else if( this.weather.link !== null ) {
                        this.weather.link = this.weather.link+'&partner='+this.partner_code;
                    }

                    this.loading = false;

                    if(this.searching == true){
                        setTimeout(function(){
                            this.$refs['search-input'].focus();
                        }.bind(this), 250);
                    }

                    this.searching = false;

                }.bind(this),
                error: function(error){
                    console.log("ERROR", error);
                },
            });
        },

        get_weather_icon(icon_number){

            var icon = "/asset/section/AccuWeather/icons/";
            switch (icon_number) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    icon += "icon-1-sunny.png";
                    break;
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                    icon += "icon-2-mostly-sunny.png";
                    break;
                case 11:
                case 12:
                case 13:
                case 14:
                    icon += "icon-3-showers.png";
                    break;
                case 15:
                case 16:
                case 17:
                    icon += "icon-4-thunder-showers.png";
                    break;
                case 18:
                    icon += "icon-5-rain.png";
                    break;
                case 19:
                case 20:
                case 21:
                    icon += "icon-6-flurries.png";
                    break;
                case 22:
                case 23:
                    icon += "icon-7-snow.png";
                    break;
                case 24:
                case 25:
                case 26:
                case 29:
                    icon += "icon-8-snow-ice.png";
                    break;
                case 30:
                    icon += "icon-9-hot.png";
                    break;
                case 31:
                    icon += "icon-10-cold.png";
                    break;
                case 32:
                    icon += "icon-11-windy.png";
                    break;
                case 33:
                case 34:
                    icon += "icon-12-clear.png";
                    break;
                case 35:
                case 36:
                    icon += "icon-13-partly-cloudy.png";
                    break;
                case 37:
                case 38:
                    icon += "icon-13-partly-cloudy.png";
                    break;
                case 39:
                case 40:
                    icon += "icon-14-cloudy-with-showers.png";
                    break;
                case 41:
                case 42:
                    icon += "icon-15-cloudy-with-t-showers.png";
                    break;
                case 43:
                    icon += "icon-16-cloudy-with-flurries.png";
                    break;
                case 44:
                    icon += "icon-17-cloudy-with-snow.png";
                    break;
                default:
                    break;
            }

            return icon;
        },

        closeWidget(event) {
            // console.log(event);
            this.show_weather_box = false;
            this.force_show_weather_box_flag = false;
        },

        force_show_weather_box(){
            this.force_show_weather_box_flag = true;
        },

        //if user mouseleave
        check_mouse_leave(){
            if(this.force_show_weather_box_flag == true ){
                this.show_weather_box = true;
            }else{
                this.show_weather_box = false;
            }
        }

    }
}
</script>